import { getGestionMovementAmounts } from './gestionAmounts'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { formatCurrency, formatDate } from '../../../../../utils/formatter'
import { Text } from '../../../../ui'
import CustomButton from '../../../../ui/CustomButton'
import ModalEdit from './ModalEdit'
import { OrganizationAPI } from '../../../../../../api/organization.api'
import GlobalContext from '../../../../../../context/global-context'
import clsx from 'clsx'
import traslation from '../../../../../../components/modules/ui/traslation/traslationAdministracion.json'
import QuestionIcon from '@mui/icons-material/HelpOutline'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import LoaderAdm from '../../../../../../assets/svgIcons/LoaderAdm.json'
import Lottie from 'lottie-react'
import { sileo } from 'sileo'
import {
  isPreviousYearConciliationLinkage,
  normalizeConciliationLinkageItem
} from '../../../../../utils/normalizeConciliationLinkage'

const normalizeGestionLinkage = linkage => {
  const normalized = normalizeConciliationLinkageItem(linkage)
  if (!normalized || typeof normalized !== 'object') return normalized
  const movementTable = [normalized?.tabla, normalized?.tablaPrincipal]
    .map(Number)
    .find(value => value === 6 || value === 7)
  const amount = Number(normalized?.monto ?? normalized?.montoTotal ?? 0) || 0
  const accountName = String(normalized?.nombreCuentaBanco ?? '').trim()

  return {
    ...normalized,
    glosa: normalized.glosa ?? normalized.descripcion,
    fechaPago: normalized.fechaPago ?? normalized.fecha,
    montoRelacionado:
      Number(normalized.montoRelacionado ?? 0) !== 0
        ? normalized.montoRelacionado
        : normalized.monto ?? normalized.montoTotal ?? 0,
    montoCargo:
      movementTable === 7 && Number(normalized.montoCargo ?? 0) === 0
        ? amount
        : normalized.montoCargo,
    montoAbono:
      movementTable === 6 && Number(normalized.montoAbono ?? 0) === 0
        ? amount
        : normalized.montoAbono,
    nombreCuentaBanco: accountName
      ? normalized.nombreCuentaBanco
      : normalized.nombreBanco ?? normalized.name,
    numeroCuentaBanco:
      normalized.numeroCuentaBanco ?? normalized.numeroBanco ?? normalized.numero
  }
}

const normalizeGestionMovement = movement => ({
  ...movement,
  status: movement?.libro?.status ?? movement?.status,
  linkage: Array.isArray(movement?.linkage)
    ? movement.linkage.map(normalizeGestionLinkage)
    : movement?.linkage
      ? normalizeGestionLinkage(movement.linkage)
      : movement?.linkage
})

const normalizeGestionResponse = response => {
  const payload = response?.data ?? response
  if (Array.isArray(payload)) return { data: payload.map(normalizeGestionMovement) }
  if (!payload || typeof payload !== 'object') return { data: [] }
  return {
    ...response,
    data: Array.isArray(payload.data)
      ? payload.data.map(normalizeGestionMovement)
      : Array.isArray(response?.data)
        ? response.data.map(normalizeGestionMovement)
        : payload.data
  }
}

const getGestionLinkName = link =>
  link?.nombreCuentaBanco || link?.nombreBanco || link?.name || ''

const getGestionLinkMovementAmount = (link, tipo) => {
  const legacyAmount = tipo === 'Proveedores' ? link?.montoCargo : link?.montoAbono
  return Number(legacyAmount ?? 0) !== 0
    ? legacyAmount
    : link?.monto ?? link?.montoTotal ?? 0
}

const getGestionLinkSettledAmount = link =>
  Number(link?.montoRelacionado ?? 0) !== 0
    ? link?.montoRelacionado
    : link?.monto ?? link?.montoTotal ?? 0

const getGestionMovementStatus = (movement, link) =>
  movement?.libro?.status ?? movement?.status ?? link?.status ?? 'PENDIENTE'

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#000033',
    color: '#ffff',
    fontSize: '0.75rem',
    padding: '6px 12px',
    borderRadius: '6px'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#000033'
  }
}))

const InputField = ({ label, type = 'text', value, onChange, onClick, disabled = false }) => (
  <div>
    <label className='block text-[12px] font-medium text-gray-700'>{label}</label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      onClick={onClick}
      disabled={disabled}
      className={`mt-1 block w-full rounded-full border-gray-300 shadow-sm sm:text-xs
        ${
          disabled
            ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
            : 'focus:border-indigo-500 focus:ring-indigo-500'
        }
      `}
    />
  </div>
)

const VistaDetalle = ({ item, onVolver, dataClienteProv,yearFilter }) => {
  const modalEditRef = useRef()
  const [, setOpen] = useState(false)
  const [switchGetData, setSwitchGetData] = useState(false)
  const { currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [data, setData] = useState({})
  const [idsSeleccionados, setIdsSeleccionados] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [, setHabilitarNoConsiderar] = useState(false)
  const [, setHabilitarReconciliar] = useState(false)
  const [, setHabilitarDeshacer] = useState(false)
  const [selectedLibros] = useState([])
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [showUnlinkAllConfirm, setShowUnlinkAllConfirm] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const [dataEmpr, setDataEmp] = useState({})
  const [dataModal, setDataModal] = useState({
    idLibro: '',
    status: '',
    type: '',
    code: '',
    idEmpresa: ''
  })
  const [formData, setFormData] = useState({
    nombre: item.nombre || '',
    rut: item.rut || '',
    contacto: item.contacto || '',
    mail: item.mail || '',
    telefono: item.telefono || '',
    clasificacion: item.clasificacion || '',
    plazoPago: item.plazoPago || ''
  })

  const getData = async () => {
    try {
      const tipoMovimiento = item.tipo
      const typeValue =
        item?.nombreFolio === 'Boleta'
          ? 'honorario'
          : tipoMovimiento === 'Proveedores'
            ? 'compra'
            : 'venta'

      if (typeValue === 'honorario') {
        console.warn(
          '[Gestion][VistaDetalle] saltando getGestion para tipo honorario; usando movimientos precargados',
          {
            businessId: currentBusiness.id,
            idEmpresa: item.idEmpresa,
            type: typeValue,
            year: yearFilter
          }
        )
        setData({ data: (item.movimientos ?? []).map(normalizeGestionMovement) })
        setIsLoadingData(false)
        return
      }

      const resp = await organizationAPI.getGestion({
        businessId: currentBusiness.id,
        idEmpresa: item.idEmpresa,
        type: typeValue,
        year: yearFilter
      })

      setData(normalizeGestionResponse(resp))
    } catch (error) {
      console.error('Error al obtener datos', error)
    }
    setIsLoadingData(false)
  }

  const getDatosEmpr = async () => {
    try {
      const params = {
        businessId: currentBusiness.id,
        idEmpresa: item.idEmpresa
      }
      if (item?.nombreFolio === 'Boleta') {
        params.type = 'honorario'
      }
      const resp = await organizationAPI.getEmpresa(params)
      setDataEmp(resp.data)
    } catch (error) {
      console.error('Error al obtener datos', error)
    }
    setIsLoadingData(false)
  }

  useEffect(() => {
    setIsLoadingData(true)
    getData()
    getDatosEmpr()
  }, [currentBusiness])

  useEffect(() => {
    if (!switchGetData) return
    setIsLoadingData(true)
    getData()
    getDatosEmpr()
    setSwitchGetData(false)
  }, [switchGetData])

useEffect(() => {
  if (!item) return

  const primerMovimiento = item.movimientos?.[0]
  const nombreFolio = item?.nombreFolio ?? primerMovimiento?.nombreFolio

  const tipoOrigen = item?.tipo ?? primerMovimiento?.tipo

  let type = ''
  if (nombreFolio === 'Boleta') {
    type = 'honorario'
  } else if (tipoOrigen === 'Proveedores') {
    type = 'compra'
  } else if (tipoOrigen === 'Cliente') {
    type = 'venta'
  }

  const idLibro = primerMovimiento?.libro?.idPrincipal ?? item.idPrincipal

  setDataModal({
    idLibro,
    status: primerMovimiento?.libro?.status ?? primerMovimiento?.status ?? 'PENDIENTE',
    type,
    code: primerMovimiento?.code,
    idEmpresa: item.idEmpresa
  })

  setOpen(true)
}, [item])


  useEffect(() => {
    if (dataEmpr) {
      setFormData({
        contacto: dataEmpr.contact || '',
        mail: dataEmpr.mail || '',
        telefono: dataEmpr.phone || '',
        diasVencimiento: dataEmpr.diasVencimiento || ''
      })
    }
  }, [dataEmpr])

  const { totalFacturado, saldoPorCobrar } = useMemo(() => {
    return (data?.data || []).reduce((totals, movement) => {
      const amounts = getGestionMovementAmounts(movement)
      return {
        totalFacturado: totals.totalFacturado + amounts.totalFacturado,
        saldoPorCobrar: totals.saldoPorCobrar + amounts.saldoPorCobrar
      }
    }, { totalFacturado: 0, saldoPorCobrar: 0 })
  }, [data])

  const styles = {
    table: 'w-full min-w-[920px] table-auto text-[0.65rem] sm:text-[0.725rem] border-collapse leading-tight font-sans',
    thead: 'sticky top-0 z-10 bg-white',
    th: 'py-2 px-1 sm:px-2 w-auto max-w-[140px] text-center break-words border-b border-gray-200 uppercase text-[0.55rem] sm:text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-200 hover:bg-gray-100/50',
    td: 'py-2 px-1 sm:px-2 w-auto max-w-[220px] text-center break-words align-top',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.6rem] sm:text-[0.65rem]',
    text: 'text-[0.6rem] sm:text-[0.705rem] text-gray-500'
  }

  const handleChange = field => e => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }))
  }

  useEffect(() => {
    const cuenta =
      item.movimientos && item.movimientos.length > 0
        ? `${item.movimientos[0].codigoCuenta} - ${item.movimientos[0].nombreCuenta}`
        : ''

    setFormData(prev => ({
      ...prev,
      clasificacion: cuenta
    }))
  }, [item])

  /*const handleCheckboxChange = (checked, linkage) => {
    const id = linkage?.idPrincipal
    if (!id) return
    let nuevosIds
    if (checked) {
      nuevosIds = [...new Set([...idsSeleccionados, id])]
    } else {
      nuevosIds = idsSeleccionados.filter(prevId => prevId !== id)
    }
    setIdsSeleccionados(nuevosIds)
    setHabilitarNoConsiderar(nuevosIds.length > 0)
  }

  console.log(idsSeleccionados)
  const botonReonciliar = async () => {
    try {
      const payload = {
        ids: idsSeleccionados
      }
      console.log(payload)
      const resp = await organizationAPI.patchRatificar(currentBusiness.id, payload);
      console.info(resp);
      setSwitchGetData(true)
    } catch (error) {
      console.error('Error al obtener datos', error);
    }
  }*/

  const handleEmpresa = async () => {
    try {
      const payload = {
        contact: formData.contacto,
        mail: formData.mail,
        phone: formData.telefono
      }
      const resp = await organizationAPI.patchEmpresa(currentBusiness.id, item.idEmpresa, payload)
      console.info(resp)
      setSwitchGetData(true)
    } catch (error) {
      console.error('Error al obtener datos', error)
    }
  }

  const botonAnular = async () => {
    const payload = {
      ids: idsSeleccionados,
      desvincular: true
    }
    return organizationAPI.patchAnular(currentBusiness.id, payload)
  }

  const botonResetear = async () => {
    const payload = {
      empresaSiiId: item.idEmpresa,
      year: yearFilter
    }
    return organizationAPI.postResetear(currentBusiness.id, payload)
  }

  const handleCaja = async () => {
    try {
      const year = new Date().getFullYear() - 1

      for (const idLibro of selectedLibros) {
        const payload = {
          businessId: currentBusiness.id,
          idLibro,
          year
        }

        await organizationAPI.postCajaGestion(payload)
      }
      setSwitchGetData(true)
      setHabilitarReconciliar(false)
    } catch (error) {
      console.error(error)
    }
  }

  const handleNoConsiderar = async () => {
    try {
      setIsProcessing(true)
      // 1. Siempre anular
      await botonAnular()

      // pequeña pausa opcional
      await new Promise(res => setTimeout(res, 1000))

      // 2. Si hay libros seleccionados, ejecutar handleCaja
      if (selectedLibros.length > 0) {
        await handleCaja()
      }

      // 3. Siempre resetear después
      await botonResetear()

      // Estados finales

      setSwitchGetData(true)
      setHabilitarNoConsiderar(false)
      setHabilitarReconciliar(true)
      setHabilitarDeshacer(true)
      setShowConfirmModal(false)
      setIdsSeleccionados([])
      // refresh extra opcional
      setTimeout(() => {
        setSwitchGetData(true)
      }, 1000)
    } catch (err) {
      console.error('Error en flujo No Considerar:', err)
    } finally {
      setIsProcessing(false)
    }
  }

  const tooltipMessage = (
    <div>
      <p>
        En esta sección puedes revisar los documentos del Servicio de Impuestos Internos que ya
        tienen un match con sus pagos conciliados en el banco.
      </p>
      <p>
        Si detectas que un pago no corresponde al periodo en que estás trabajando, puedes marcarlo
        en el checkbox correspondiente para que el sistema lo excluya de la conciliación y realice
        una nueva reconciliación automática.
      </p>
      <p>
        Además, también puedes eliminar o dejar sin considerar documentos y movimientos bancarios.
        Esto es útil cuando dichos documentos corresponden a pagos realizados en un periodo anterior
        o incluso en un año anterior, y por lo tanto no deben ser considerados en la conciliación
        actual.
      </p>
      <p>
        Al hacerlo, los pagos quedarán correctamente asignados: movimientos del año 2025 con pagos
        del año 2025, aplicando el sistema FIFO (First In, First Out) utilizado por el software.
      </p>
      <p>
        Es importante considerar que, en algunos casos, el pago no quedará vinculado exactamente a
        la factura específica; sin embargo, gracias al FIFO, se determina con precisión el monto de
        la deuda por cobrar, manteniendo el control correcto de tus cuentas de clientes.
      </p>
      <p>
        Finalmente, para aplicar los cambios y guardar la operación, debes presionar Reconciliar.
      </p>
    </div>
  )
  const sortedMovimientos = useMemo(() => {
    const parseFecha = f => {
      if (!f) return new Date(1900, 0, 1)
      if (/^\d{4}-\d{2}-\d{2}$/.test(f)) return new Date(f + 'T00:00:00')
      if (/^\d{2}-\d{2}-\d{4}$/.test(f)) {
        const [d, m, y] = f.split('-').map(Number)
        return new Date(y, m - 1, d)
      }
      return new Date(f)
    }

    return (data?.data || [])
      .map(normalizeGestionMovement)
      .slice()
      .sort((a, b) => parseFecha(a?.fechaDocumento) - parseFecha(b?.fechaDocumento))
  }, [data])

  const libroIdsAsociados = useMemo(
    () =>
      [
        ...new Set(
          (data?.data || [])
            .map(mov => Number(mov?.libro?.idPrincipal))
            .filter(id => Number.isFinite(id) && id > 0)
        )
      ],
    [data]
  )

  const handleDesconciliarTodo = async () => {
    const maquina = showUnlinkAllConfirm === 'ia'
    if (!currentBusiness?.id || isProcessing) return
    if (!maquina && libroIdsAsociados.length === 0) return

    try {
      setIsProcessing(true)
      await organizationAPI.postCajaMultipleDes(
        { businessId: Number(currentBusiness.id) },
        maquina ? { maquina: true } : { ids: libroIdsAsociados }
      )
      sileo.success({
        title: 'Movimientos desconciliados',
        description: maquina
          ? 'Se completó la desconciliación masiva IA de los movimientos asociados.'
          : `Se desconciliaron ${libroIdsAsociados.length} movimientos asociados.`
      })
      setShowUnlinkAllConfirm(false)
      setSwitchGetData(true)
    } catch (error) {
      console.error('Error al desconciliar todos los movimientos asociados:', error)
      sileo.error({
        title: 'No se pudo desconciliar',
        description: 'Ocurrió un error al desconciliar los movimientos asociados.'
      })
    } finally {
      setIsProcessing(false)
    }
  }

  const getEstadoMovimiento = (mov, linkageOrdenado) => {
    if (mov.nombreDocumento === 'Nota de Crédito Electrónica') {
      const documentoAnulado = (data?.data || []).find(
        otro => String(otro.folio).trim() === String(mov.folioReferencia).trim()
      )
      if (documentoAnulado) {
        const nombreDoc = traslation.documentosContables[documentoAnulado.nombreDocumento]
        return `Anula ${nombreDoc} ${documentoAnulado.folio}`
      }
    } else {
      const notaCreditoRelacionada = (data?.data || []).find(
        otro =>
          otro.nombreDocumento === 'Nota de Crédito Electrónica' &&
          String(otro.folioReferencia).trim() === String(mov.folio).trim()
      )
      if (notaCreditoRelacionada) {
        return `Anulado por NC ${notaCreditoRelacionada.folio}`
      }
    }

    const hasCobro = linkageOrdenado?.some(l => l.glosa?.includes('Cobro'))
    const hasPago = linkageOrdenado?.some(l => l.glosa?.includes('Pago'))
    return (
      mov?.libro?.status ||
      mov?.status ||
      linkageOrdenado?.[0]?.status ||
      (hasPago ? 'PAGADO' : hasCobro ? 'COBRADO' : 'PENDIENTE')
    )
  }

  return (
    <>
      <div className={clsx('p-4 space-y-6 font-sans', isMobile ? 'overflow-x-hidden' : 'overflow-x-auto')}>
        <div className={clsx('flex justify-between items-center mb-4', isMobile && 'flex-col items-start gap-2')}>
          <button
            onClick={onVolver}
            className='text-sm font-bold border-2 rounded-full px-2 py-1 bg-accent2 text-white'
          >
            {' '}
            Volver
          </button>
          <CustomButton
            className='text-sm font-bold border-2 border-gray-400 rounded-lg'
            title={
              item.movimientos &&
              item.movimientos.length > 0 &&
              item.movimientos[0].tipo === 'Cliente'
                ? 'Cliente'
                : 'Proveedores'
            }
          >
            {item.movimientos &&
            item.movimientos.length > 0 &&
            item.movimientos[0].tipo === 'Cliente'
              ? 'Cliente'
              : 'Proveedores'}
          </CustomButton>
        </div>

        <div className={clsx('grid gap-6', isMobile ? 'grid-cols-1' : 'grid-cols-3')}>
          {/* Datos de la empresa y contacto */}
          <div className='space-y-2'>
            <InputField
              label='Razon Social'
              value={formData.nombre}
              onChange={handleChange('nombre')}
              disabled
            />
            <InputField label='RUT' value={formData.rut} onChange={handleChange('rut')} disabled />
            <InputField
              label='Persona Contacto'
              value={formData.contacto}
              onChange={handleChange('contacto')}
            />
            <InputField label='Correo' value={formData.mail} onChange={handleChange('mail')} />
            <InputField
              label='Teléfono'
              value={formData.telefono}
              onChange={handleChange('telefono')}
            />
          </div>

          {/* Clasificación y centros de costo */}
          <div className={clsx('space-y-2', !isMobile && 'col-span-2')}>
            <ModalEdit
              idLibro={dataModal.idLibro}
              status={dataModal.status}
              type={dataModal.type}
              code={dataModal.code}
              idEmpresa={dataModal.idEmpresa}
              diasVencimiento={dataEmpr?.diasVencimiento}
              setSwitchGetData={setSwitchGetData}
              ref={modalEditRef}
            />
            <div className='pt-7 text-center'>
              <CustomButton
                className='rounded-full px-2 py-1.5'
                color='accent2'
                title='Guardar'
                onClick={async () => {
                  const saved = await modalEditRef.current?.submit()
                  if (saved) await handleEmpresa()
                }}
              />
            </div>
          </div>
        </div>

        {/* Tarjetas de totales */}
        <div className={clsx('grid gap-4 text-center', isMobile ? 'grid-cols-1' : 'grid-cols-2')}>
          <div className='border p-4 shadow rounded bg-white'>
            <div className='text-xs text-gray-600'>Total Facturado</div>
            <div className={clsx('font-bold', isMobile ? 'text-xl' : 'text-2xl')}>{formatCurrency(totalFacturado)}</div>
          </div>
          <div className='border p-4 shadow rounded bg-white'>
            <div className='text-xs text-gray-600'>
              {item.tipo === 'Cliente' ? 'Monto Por Cobrar' : 'Monto Por Pagar'}
            </div>
            <div className={clsx('font-bold', isMobile ? 'text-xl' : 'text-2xl')}>{formatCurrency(saldoPorCobrar)}</div>
          </div>
          {/*<div className="border p-4 shadow rounded bg-white">
          <div className="text-xs text-gray-600">Monto Anticipos</div>
          <div className="text-2xl font-bold">{formatCurrency(montoAnticipo)}</div>
        </div>*/}
        </div>

        <div className='overflow-x-auto'>
          <div className='flex items-center justify-between mt-6 mb-2'>
            <h3 className='font-bold text-sm'>Movimientos Asociados</h3>

            {/* Icono con tooltip a la derecha */}
            <CustomTooltip title={tooltipMessage} arrow>
              <QuestionIcon
                className='text-gray-500 cursor-pointer hover:text-primary'
                style={{ fontSize: '25px' }}
              />
            </CustomTooltip>
          </div>
          {isLoadingData ? (
            <div className='flex items-center justify-center h-full'>
              <Lottie animationData={LoaderAdm} loop style={{ width: 300, height: 300 }} />
            </div>
          ) : (
            <div className='overflow-x-auto'>
              <div className='h-full mt-2'>
                {![39, 41, 48].includes(item.code) && isMobile && (
                  <div className='space-y-3'>
                    {sortedMovimientos.map((mov, i) => {
                      const linkageOrdenado = mov.linkage
                        ?.slice()
                        .sort((a, b) => new Date(a.fechaPago) - new Date(b.fechaPago))
                      const estadoPersonalizado = getEstadoMovimiento(mov, linkageOrdenado)
                      const isPreviousYear = linkageOrdenado?.some(
                        isPreviousYearConciliationLinkage
                      )
                      const showBankDetails = !isPreviousYear && !estadoPersonalizado?.startsWith('Anula') && !estadoPersonalizado?.startsWith('Anulado')
                      return (
                        <div key={i} className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'>
                          <div className='flex items-start justify-between gap-2'>
                            <div>
                              <Text className='text-xs font-bold'>
                                {traslation.documentosContables[mov.nombreDocumento]} · {mov.folio}
                              </Text>
                              <Text className='text-[11px] text-gray-500'>
                                {formatDate(mov.fechaDocumento || mov.fecha)}
                              </Text>
                            </div>
                            <Text className='text-xs font-semibold'>
                              {formatCurrency(mov.montoTotal || mov.pagado)}
                            </Text>
                          </div>

                          <div className='mt-2 text-xs text-gray-600'>
                            <Text className='text-[10px] text-gray-400'>Razon Social</Text>
                            <Text className='text-xs font-semibold'>{item.nombre}</Text>
                          </div>

                          <div className='mt-2 flex items-center justify-between text-xs'>
                            <div>
                              <Text className='text-[10px] text-gray-400'>Estado</Text>
                              <Text className='text-xs font-semibold'>{estadoPersonalizado}</Text>
                              {isPreviousYear && (
                                <Text className='text-[11px] text-gray-500'>año anterior</Text>
                              )}
                            </div>
                            {!isPreviousYear && (
                              <div className='text-right'>
                                <Text className='text-[10px] text-gray-400'>
                                  {item.tipo === 'Proveedores' ? 'Cargo' : 'Abono'}
                                </Text>
                                {linkageOrdenado?.map((link, j) => (
                                  <Text key={`cargoabono-${j}`} className='text-xs font-semibold'>
                                    {formatCurrency(
                                      item.tipo === 'Proveedores'
                                        ? getGestionLinkMovementAmount(link, 'Proveedores')
                                        : getGestionLinkMovementAmount(link, 'Cliente')
                                    )}
                                  </Text>
                                ))}
                              </div>
                            )}
                          </div>

                          {showBankDetails && linkageOrdenado?.length > 0 && (
                            <div className='mt-2 space-y-2'>
                              {linkageOrdenado.map((link, j) => (
                                <div key={`link-${j}`} className='rounded-xl bg-gray-50 p-2'>
                                  <Text className='text-[10px] text-gray-400'>Banco</Text>
                                  <Text className='text-xs font-semibold'>
                                    {getGestionLinkName(link)}
                                  </Text>
                                  <Text className='text-[11px] text-gray-500'>
                                    {formatDate(link.fechaPago)}
                                  </Text>
                                  <Text className='text-[11px] text-gray-500'>
                                    Monto saldado: {formatCurrency(getGestionLinkSettledAmount(link))}
                                  </Text>
                                  <Text className='text-[11px] text-gray-500'>
                                    Estado: {getGestionMovementStatus(mov, link)}
                                  </Text>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )
                    })}
                  </div>
                )}

                {![39, 41, 48].includes(item.code) && !isMobile && (
                  <table className={styles.table}>
                    <thead className={styles.thead}>
                      <tr>
                        <th className={styles.th}>Razon Social</th>
                        <th className={styles.th}>Documento</th>
                        <th className={styles.th}>Fecha</th>
                        <th className={styles.th}>Monto Total</th>
                        <th className={styles.th}></th>
                        <th className={styles.th}>Banco</th>
                        <th className={styles.th}>
                          {item.tipo === 'Proveedores' ? 'Cargo' : 'Abono'}
                        </th>
                        <th className={styles.th}>Monto Saldado</th>
                        <th className={styles.th}>Estado</th>
                      </tr>
                    </thead>
                    <tbody className={styles.tbody}>
                      {sortedMovimientos.map((mov, i) => {
                        const linkageOrdenado = mov.linkage
                          ?.slice()
                          .sort((a, b) => new Date(a.fechaPago) - new Date(b.fechaPago))
                        let estadoPersonalizado = null

                        if (mov.nombreDocumento === 'Nota de Crédito Electrónica') {
                          const documentoAnulado = (data?.data || []).find(
                            otro =>
                              String(otro.folio).trim() === String(mov.folioReferencia).trim()
                          )

                          if (documentoAnulado) {
                            const nombreDoc =
                              traslation.documentosContables[documentoAnulado.nombreDocumento]
                            estadoPersonalizado = `Anula ${nombreDoc} ${documentoAnulado.folio}`
                          }
                        } else {
                          const notaCreditoRelacionada = (data?.data || []).find(
                            otro =>
                              otro.nombreDocumento === 'Nota de Crédito Electrónica' &&
                              String(otro.folioReferencia).trim() === String(mov.folio).trim()
                          )

                          if (notaCreditoRelacionada) {
                            estadoPersonalizado = `Anulado por NC ${notaCreditoRelacionada.folio}`
                          }
                        }

                        return (
                          <tr key={i} className={clsx(styles.tr)}>
                              <td className={styles.td}>
                                <Text className={styles.boldText}>{item.nombre}</Text>
                              </td>

                              <td className={styles.td}>
                                <Text className={styles.boldText}>
                                  {traslation.documentosContables[mov.nombreDocumento]}
                                </Text>
                                <Text className={styles.text}>{mov.folio}</Text>
                              </td>

                              <td className={styles.td}>
                                <Text className={styles.boldText}>
                                  {formatDate(mov.fechaDocumento || mov.fecha)}
                                </Text>
                              </td>

                              <td className={styles.td}>
                                <Text className={styles.boldText}>
                                  {formatCurrency(mov.montoTotal || mov.pagado)}
                                </Text>
                              </td>

                              {linkageOrdenado?.some(isPreviousYearConciliationLinkage) ? (
                                <>
                                  <td className={styles.td}></td>
                                  <td className={styles.td}></td>
                                  <td className={styles.td}></td>
                                  <td className={styles.td}></td>

                                  <td className={clsx(styles.td, 'text-center')}>
                                    <Text className={styles.boldText}>
                                      {estadoPersonalizado ||
                                        linkageOrdenado?.[0]?.status ||
                                        (linkageOrdenado?.some(l => l.glosa?.includes('Pago'))
                                          ? 'PAGADO'
                                          : linkageOrdenado?.some(l => l.glosa?.includes('Cobro'))
                                            ? 'COBRADO'
                                            : 'PENDIENTE')}
                                    </Text>
                                    <Text className={styles.boldText}>año anterior</Text>
                                  </td>
                                </>
                              ) : (
                                <>
                                  {estadoPersonalizado ? (
                                    <>
                                      <td className={styles.td}></td>
                                      <td className={styles.td}></td>
                                      <td className={styles.td}></td>
                                      <td className={styles.td}></td>
                                      <td className={clsx(styles.td, 'text-center')}>
                                        <Text className={styles.boldText}>
                                          {estadoPersonalizado ||
                                            linkageOrdenado?.[0]?.status ||
                                            (linkageOrdenado?.some(l => l.glosa?.includes('Pago'))
                                              ? 'PAGADO'
                                              : linkageOrdenado?.some(l =>
                                                    l.glosa?.includes('Cobro')
                                                  )
                                                ? 'COBRADO'
                                                : 'PENDIENTE')}
                                        </Text>

                                        {/* Mostrar "año anterior" solo si NO hay estadoPersonalizado */}
                                        {!estadoPersonalizado &&
                                          (linkageOrdenado?.some(l => l.glosa?.includes('Pago')) ||
                                            linkageOrdenado?.some(l =>
                                              l.glosa?.includes('Cobro')
                                            )) && (
                                            <Text className={styles.boldText}>año anterior</Text>
                                          )}
                                      </td>
                                    </>
                                  ) : (
                                    // Si NO tiene estado personalizado → mostrar info del banco normalmente
                                    <>
                                      <td colSpan={2} className={styles.td}>
                                        <div className='grid grid-cols-1 gap-x-3 gap-y-2 items-start'>
                                          {linkageOrdenado?.map((link, j) => (
                                            <React.Fragment key={j}>
                                              {/*<input
                              type="checkbox"
                              className="rounded mt-1"
                              onChange={(e) => handleCheckboxChange(e.target.checked, link)}
                            />*/}
                                              <></>
                                              <div>
                                                <Text className={styles.boldText}>
                                                  {getGestionLinkName(link)}
                                                </Text>
                                                <Text className={styles.text}>
                                                  {formatDate(link.fechaPago)}
                                                </Text>
                                              </div>
                                            </React.Fragment>
                                          ))}
                                        </div>
                                      </td>

                                      <td className={styles.td}>
                                        {linkageOrdenado?.map((link, j) => (
                                          <div key={`cargoabono-${j}`} className='py-1'>
                                            <Text className={styles.boldText}>
                                              {formatCurrency(
                                                getGestionLinkMovementAmount(link, item.tipo)
                                              )}
                                            </Text>
                                            <br />
                                          </div>
                                        ))}
                                      </td>

                                      <td className={styles.td}>
                                        {linkageOrdenado?.map((link, j) => (
                                          <div key={`banco-${j}`} className='py-1'>
                                            <Text className={styles.boldText}>
                                              {formatCurrency(getGestionLinkSettledAmount(link))}
                                            </Text>
                                            <br />
                                          </div>
                                        ))}
                                      </td>

                                      <td className={styles.td}>
                                        {linkageOrdenado?.length > 0 ? (
                                          linkageOrdenado.map((link, j) => (
                                            <div key={`status-${j}`} className='py-1'>
                                              <Text className={styles.boldText}>
                                                {getGestionMovementStatus(mov, link)}
                                              </Text>
                                              <br />
                                            </div>
                                          ))
                                        ) : (
                                          <Text className={styles.boldText}>PENDIENTE</Text>
                                        )}
                                      </td>
                                    </>
                                  )}
                                </>
                              )}
                            </tr>
                          )
                        })}
                    </tbody>
                  </table>
                )}
                {[39, 41, 48].includes(item.code) && Array.isArray(item.resumenPorMes) && isMobile && (
                  <div className='space-y-3'>
                    {item.resumenPorMes.map((row, i) => (
                      <div key={i} className='rounded-2xl border border-gray-100 bg-white shadow-sm p-3'>
                        <Text className='text-xs font-bold'>{row.doc}</Text>
                        <div className='mt-2 grid grid-cols-2 gap-2 text-xs'>
                          <div>
                            <Text className='text-[10px] text-gray-400'>Mes</Text>
                            <Text className='text-xs font-semibold'>{row.mes}</Text>
                          </div>
                          <div className='text-right'>
                            <Text className='text-[10px] text-gray-400'>Cantidad</Text>
                            <Text className='text-xs font-semibold'>{row.cantidad}</Text>
                          </div>
                        </div>
                        <div className='mt-2 text-right'>
                          <Text className='text-[10px] text-gray-400'>Monto</Text>
                          <Text className='text-xs font-semibold'>{formatCurrency(row.monto)}</Text>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {[39, 41, 48].includes(item.code) && Array.isArray(item.resumenPorMes) && !isMobile && (
                  <table className={styles.table}>
                    <thead className={styles.thead}>
                      <tr>
                        <th className={styles.th}>Documento</th>
                        <th className={styles.th}>Mes</th>
                        <th className={styles.th}>Cantidad</th>
                        <th className={styles.th}>Monto</th>
                      </tr>
                    </thead>

                    <tbody className={styles.tbody}>
                      {item.resumenPorMes.map((row, i) => (
                        <tr key={i} className={clsx(styles.tr)}>
                          <td className={styles.td}>
                            <Text className={styles.boldText}>{row.doc}</Text>
                          </td>
                          <td className={styles.td}>
                            <Text className={styles.boldText}>{row.mes}</Text>
                          </td>
                          <td className={styles.td}>
                            <Text className={styles.boldText}>{row.cantidad}</Text>
                          </td>
                          <td className={styles.td}>
                            <Text className={styles.boldText}>
                              {formatCurrency(row.monto)}
                            </Text>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                <div className='mt-4 flex flex-wrap justify-end gap-3'>
                  <CustomButton
                    className='rounded-full'
                    color='accent2'
                    title='Desconciliar Todo'
                    onClick={() => setShowUnlinkAllConfirm('manual')}
                    disabled={libroIdsAsociados.length === 0 || isProcessing}
                  />
                  {/* Deshabilitado temporalmente hasta habilitar su uso.
                  <CustomTooltip title='Desconciliación Masiva IA' arrow>
                    <span>
                      <CustomButton
                        className='rounded-full disabled:cursor-not-allowed'
                        color='accent3'
                        title='Desconciliación Masiva IA'
                        onClick={() => setShowUnlinkAllConfirm('ia')}
                        disabled={!currentBusiness?.id || isProcessing}
                      />
                    </span>
                  </CustomTooltip>
                  */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/*<div className="space-x-2 text-right">
        <CustomButton className="rounded-full" color="accent3" title="No considerar" onClick={() => setShowConfirmModal(true)} disabled={!habilitarNoConsiderar}  />
          <CustomButton className="rounded-full" color="accent2" title="Reconciliar"  onClick={() => setSwitchGetData(true)} disabled={!habilitarReconciliar}/>
      </div>*/}
      {showConfirmModal && (
        <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
          <div className='bg-white rounded-xl shadow-lg p-8 w-[600px] h-[360px] max-w-[90%] flex flex-col justify-between'>
            <div className='flex flex-col items-center mb-2'>
              <div className='w-14 h-14 border-2 border-black rounded-full flex items-center justify-center'>
                <span className='text-3xl'>!</span>
              </div>
              <h2 className='text-2xl font-bold mt-2'>Advertencia</h2>
            </div>

            {/* Texto */}
            <p className='text-lg text-center leading-relaxed'>
              Los movimientos marcados no volverán a ser considerados por el algoritmo de TryLuca y
              solo podrán ser conciliados de forma manual.
            </p>

            {/* Botones */}
            <div className='flex justify-end space-x-4'>
              <CustomButton
                className='rounded-full px-6 py-2 text-base'
                title='Cancelar'
                color='primary'
                onClick={() => setShowConfirmModal(false)}
                disabled={isProcessing}
              />
              <CustomButton
                className='rounded-full px-6 py-2 text-base'
                title='Continuar'
                color='accent3'
                onClick={handleNoConsiderar}
                disabled={isProcessing}
              />
            </div>
          </div>
        </div>
      )}
      {showUnlinkAllConfirm && (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
          <div className='flex w-[520px] max-w-[90%] flex-col gap-6 rounded-xl bg-white p-8 shadow-lg'>
            <div className='text-center'>
              <h2 className='text-xl font-bold'>
                {showUnlinkAllConfirm === 'ia' ? 'Desconciliación Masiva IA' : 'Desconciliar todos los movimientos'}
              </h2>
              <p className='mt-3 text-sm text-gray-600'>
                {showUnlinkAllConfirm === 'ia'
                  ? 'Se solicitará la desconciliación masiva IA de los movimientos asociados. Esta acción quitará sus conciliaciones realizadas por la máquina.'
                  : `Se desconciliarán ${libroIdsAsociados.length} movimientos asociados. Esta acción quitará sus conciliaciones actuales.`}
              </p>
            </div>
            <div className='flex justify-end gap-3'>
              <CustomButton
                className='rounded-full px-5 py-2'
                title='Cancelar'
                color='primary'
                onClick={() => setShowUnlinkAllConfirm(false)}
                disabled={isProcessing}
              />
              <CustomButton
                className='rounded-full px-5 py-2'
                title={isProcessing ? 'Desconciliando...' : showUnlinkAllConfirm === 'ia' ? 'Desconciliación Masiva IA' : 'Desconciliar Todo'}
                color='accent3'
                onClick={handleDesconciliarTodo}
                disabled={isProcessing}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default VistaDetalle
